var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{staticClass:"mb-32",attrs:{"cols":"12"}},[_c('b-row',{staticClass:"mt-n32",attrs:{"align-h":"between"}},[_c('b-col',{staticClass:"hp-flex-none w-auto mt-32"},[_c('breadcrumb')],1),_c('action-button')],1)],1),_c('b-col',{staticClass:"mb-32",attrs:{"cols":"12"}},[_c('b-row',[_c('invoice'),_c('invoice-actions')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }